document.addEventListener("DOMContentLoaded", function () {
  const sectionEl = document.getElementById("cushion-configurator");
  if (!sectionEl) return;

  const WORKER_URL      = "https://curtain-configurator.ka-ching.workers.dev";
  const ACCENT_FORMULAS = new Set(["cushion_thick", "cushion_thin", "cushion_extra_thick", "backrest_padded"]);
  const STEP_FABRIC     = 1;
  const STEP_COLOR      = 2;
  const STEP_MEASURE    = 3;
  const STEP_SUMMARY    = 4;

  const MSG_NO_BASE_COLOR   = sectionEl.dataset.msgNoBase   || "Bitte eine Grundfarbe wählen.";
  const MSG_NO_ACCENT_COLOR = sectionEl.dataset.msgNoAccent || "Bitte auch eine Akzentfarbe wählen.";
  const MSG_NO_FABRIC       = sectionEl.dataset.msgNoFabric || "Bitte einen Stoff wählen.";
  const MSG_SOLD_OUT         = (sectionEl.dataset.msgSoldOut || "- bald wieder verfügbar").trim();
  const MSG_SOLD_OUT_BLOCKED = sectionEl.dataset.msgSoldOutBlocked || "Diese Farbe ist derzeit ausverkauft und kann nicht bestellt werden.";

  const currencySymbol = window.Shopify?.currency?.symbol || "€";
  const cushionData    = JSON.parse(localStorage.getItem("cushionData") || "{}");

  if (!cushionData.variantId) {
    sectionEl.innerHTML =
      '<div class="container"><p>Bitte wähle zuerst ein Produkt aus. ' +
      '<a href="/collections">Zur Übersicht</a></p></div>';
    return;
  }

  const siblings      = Array.isArray(cushionData.siblingVariants) ? cushionData.siblingVariants : [];
  const hasFabricStep = siblings.length > 1;
  const firstStep     = hasFabricStep ? STEP_FABRIC : STEP_COLOR;

  if (!cushionData.typeTitle) {
    cushionData.typeTitle = cushionData.variantTitle || "";
  }

  sectionEl.classList.toggle("has-fabric-step", hasFabricStep);

  // ─── Config-Resolution (Block > Section-Fallback) ───────────────────────────

  function resolveConfig() {
    let blockConfigs = { defaults: {}, products: {} };
    try {
      const el = document.getElementById("cushion-block-configs");
      if (el) blockConfigs = JSON.parse(el.textContent);
    } catch (e) {}

    const defaults  = blockConfigs.defaults  || {};
    const productId = String(cushionData.productId || "");
    const override  = (blockConfigs.products || {})[productId] || {};

    function pick(key, fallback) {
      const v = override[key];
      if (v !== null && v !== undefined && v !== "") return v;
      const d = defaults[key];
      if (d !== null && d !== undefined && d !== "") return d;
      return fallback;
    }
    function pickNum(key, fallback) {
      const v = override[key];
      if (v !== null && v !== undefined) return v;
      const d = defaults[key];
      if (d !== null && d !== undefined) return d;
      return fallback;
    }

    return {
      labelWidth:        pick("labelWidth",        "Breite"),
      labelHeight:       pick("labelHeight",       "Länge"),
      placeholderWidth:  pick("placeholderWidth",  "z.B. 60"),
      placeholderHeight: pick("placeholderHeight", "z.B. 60"),
      minWidth:          pickNum("minWidth",  20),
      maxWidth:          pickNum("maxWidth",  300),
      minHeight:         pickNum("minHeight", 20),
      maxHeight:         pickNum("maxHeight", 300),
    };
  }

  const cfg = resolveConfig();

  function applyDimConfig() {
    const widthLabel = document.getElementById("cushion-width-label");
    if (widthLabel) widthLabel.textContent = `${cfg.labelWidth} (${cfg.minWidth}–${cfg.maxWidth} cm)`;
    const heightLabel = document.getElementById("cushion-height-label");
    if (heightLabel) heightLabel.textContent = `${cfg.labelHeight} (${cfg.minHeight}–${cfg.maxHeight} cm)`;

    const widthInput = document.getElementById("cushion-width");
    if (widthInput) {
      widthInput.min          = cfg.minWidth;
      widthInput.max          = cfg.maxWidth;
      widthInput.dataset.min  = cfg.minWidth;
      widthInput.dataset.max  = cfg.maxWidth;
      widthInput.placeholder  = cfg.placeholderWidth;
    }
    const heightInput = document.getElementById("cushion-height");
    if (heightInput) {
      heightInput.min         = cfg.minHeight;
      heightInput.max         = cfg.maxHeight;
      heightInput.dataset.min = cfg.minHeight;
      heightInput.dataset.max = cfg.maxHeight;
      heightInput.placeholder = cfg.placeholderHeight;
    }

    const widthError = document.getElementById("cushion-width-error");
    if (widthError) widthError.textContent = `${cfg.labelWidth} muss zwischen ${cfg.minWidth} und ${cfg.maxWidth} cm liegen`;
    const heightError = document.getElementById("cushion-height-error");
    if (heightError) heightError.textContent = `${cfg.labelHeight} muss zwischen ${cfg.minHeight} und ${cfg.maxHeight} cm liegen`;

    document.querySelectorAll(".summary-label-width").forEach(el => el.textContent = cfg.labelWidth);
    document.querySelectorAll(".summary-label-height").forEach(el => el.textContent = cfg.labelHeight);
  }

  applyDimConfig();

  // ─── State ─────────────────────────────────────────────────────────────────

  let currentStep         = firstStep;
  let selectedBaseColor     = null;
  let selectedAccentColor   = null;
  let selectedBaseSoldOut   = false;
  let selectedAccentSoldOut = false;
  let lastUnitPrice         = null;

  // ─── Linke Spalte initial befüllen ─────────────────────────────────────────

  function applyProductImage() {
    document.querySelectorAll(".step-variant-image").forEach(img => {
      if (cushionData.image) img.src = cushionData.image;
    });
  }

  applyProductImage();
  document.querySelectorAll(".cushion-summary-title").forEach(el => {
    el.textContent = cushionData.productTitle || "";
  });
  document.querySelectorAll(".cushion-summary-variant").forEach(el => {
    el.textContent = cushionData.typeTitle || cushionData.variantTitle || "";
  });

  // ─── Helpers ───────────────────────────────────────────────────────────────

  function persistCushionData() {
    try {
      localStorage.setItem("cushionData", JSON.stringify(cushionData));
    } catch (e) {}
  }

  function getActiveVariant() {
    return siblings.find(item => item.id === cushionData.variantId) || null;
  }

  function getBaseColors() {
    const current = getActiveVariant();
    if (current && Array.isArray(current.baseColors) && current.baseColors.length) {
      return current.baseColors;
    }
    if (Array.isArray(cushionData.baseColors) && cushionData.baseColors.length) {
      return cushionData.baseColors;
    }
    if (current && current.colors && current.colors.length) return current.colors;
    return cushionData.cushionColors || [];
  }

  function getAccentColors() {
    const current = getActiveVariant();
    if (usesVariantColorFields(current) || usesVariantColorFields(cushionData)) {
      if (current && Array.isArray(current.accentColors)) return current.accentColors;
      if (Array.isArray(cushionData.accentColors)) return cushionData.accentColors;
      return [];
    }
    return getBaseColors();
  }

  function usesVariantColorFields(source) {
    return Boolean(source && (Array.isArray(source.baseColors) || Array.isArray(source.accentColors)));
  }

  function hasAccentPicker() {
    const current = getActiveVariant();
    if (usesVariantColorFields(current) || usesVariantColorFields(cushionData)) {
      const accent = (current && Array.isArray(current.accentColors))
        ? current.accentColors
        : (Array.isArray(cushionData.accentColors) ? cushionData.accentColors : []);
      return accent.length > 0;
    }
    const formula = (cushionData.fabricFormula || "").trim().toLowerCase();
    return ACCENT_FORMULAS.has(formula);
  }

  function updateAccentVisibility() {
    const accentGroup = document.getElementById("accent-color-group");
    if (!accentGroup) return;
    accentGroup.hidden = !hasAccentPicker();
  }

  function showAndUpdate(selector, value) {
    document.querySelectorAll(selector).forEach(element => {
      const parent = element.closest("p, tr");
      if (!parent) return;
      const isValid = value !== null && value !== undefined && value !== "" && value !== "-";
      if (isValid) {
        element.textContent = value;
        parent.style.display = parent.tagName === "TR" ? "table-row" : "block";
      } else {
        parent.style.display = "none";
      }
    });
  }

  function formatColorProperty(name, soldOut) {
    if (!name) return "";
    if (!soldOut || !MSG_SOLD_OUT) return name;
    return `${name} ${MSG_SOLD_OUT}`;
  }

  function renderColorName(target, name, soldOut) {
    if (!target) return;
    target.replaceChildren();
    if (!name) return;
    target.append(name);
    if (soldOut && MSG_SOLD_OUT) {
      target.append(" ");
      const note = document.createElement("strong");
      note.textContent = MSG_SOLD_OUT;
      target.appendChild(note);
    }
  }

  function showAndUpdateColor(selector, name, soldOut) {
    document.querySelectorAll(selector).forEach(element => {
      const parent = element.closest("p, tr");
      if (!parent) return;
      if (!name) {
        parent.style.display = "none";
        element.replaceChildren();
        return;
      }
      renderColorName(element, name, soldOut);
      parent.style.display = parent.tagName === "TR" ? "table-row" : "block";
    });
  }

  function getDimWidth() {
    const v = parseFloat(document.getElementById("cushion-width")?.value);
    return isNaN(v) ? null : v;
  }
  function getDimHeight() {
    const v = parseFloat(document.getElementById("cushion-height")?.value);
    return isNaN(v) ? null : v;
  }

  function getQuantity() {
    return parseInt(document.getElementById("cushion-quantity")?.value) || 1;
  }

  function updateTotals() {
    const qty = getQuantity();
    document.querySelectorAll(".cushion-summary-quantity").forEach(el => {
      el.textContent = qty;
    });
    if (lastUnitPrice === null) return;
    const total = (lastUnitPrice * qty).toFixed(2);
    document.querySelectorAll(".subtotal-price, .total-price").forEach(el => {
      el.textContent = `${currencySymbol}${total}`;
    });
  }

  function updateSummary() {
    showAndUpdate(".cushion-summary-fabric", cushionData.fabricTitle);
    showAndUpdateColor(".cushion-summary-base", selectedBaseColor, selectedBaseSoldOut);
    showAndUpdateColor(".cushion-summary-accent", selectedAccentColor, selectedAccentSoldOut);
    const w = getDimWidth();
    const h = getDimHeight();
    showAndUpdate(".cushion-summary-width",  w !== null ? `${w} cm` : null);
    showAndUpdate(".cushion-summary-height", h !== null ? `${h} cm` : null);
    updateTotals();
    updateUI();
  }

  // ─── Step Navigation ────────────────────────────────────────────────────────

  const prevBtn      = document.querySelector(".cushion-configurator-sec .prev-btn");
  const nextBtn      = document.querySelector(".cushion-configurator-sec .next-btn");
  const progressFill = document.querySelector(".cushion-configurator-sec .progress-fill");

  function getVisibleSteps() {
    return hasFabricStep
      ? [STEP_FABRIC, STEP_COLOR, STEP_MEASURE, STEP_SUMMARY]
      : [STEP_COLOR, STEP_MEASURE, STEP_SUMMARY];
  }

  function updateUI() {
    const visibleSteps = getVisibleSteps();

    document.querySelectorAll(".cushion-configurator-sec .step-content").forEach(step => {
      const n = parseInt(step.dataset.step, 10);
      if (!hasFabricStep && n === STEP_FABRIC) {
        step.style.display = "none";
        return;
      }
      step.style.display = n === currentStep ? "block" : "none";
    });

    document.querySelectorAll(".cushion-configurator-sec .progress-bar .step, .cushion-configurator-sec .step-titles .title").forEach(el => {
      const n = parseInt(el.dataset.step, 10);
      const isVisible = visibleSteps.includes(n);
      const clickable = isVisible && isStepClickable(n);
      el.hidden = !isVisible;
      el.style.display = isVisible ? "" : "none";
      el.classList.toggle("active", n === currentStep);
      el.classList.toggle("is-clickable", clickable);
      if (clickable) {
        el.setAttribute("role", "button");
        el.tabIndex = 0;
        el.setAttribute("aria-disabled", "false");
      } else {
        el.removeAttribute("role");
        el.tabIndex = -1;
        el.setAttribute("aria-disabled", "true");
      }
      if (n === currentStep) {
        el.setAttribute("aria-current", "step");
      } else {
        el.removeAttribute("aria-current");
      }
    });

    document.querySelectorAll(".cushion-configurator-sec .progress-bar .step").forEach(el => {
      if (el.hidden) return;
      const n = parseInt(el.dataset.step, 10);
      const span = el.querySelector("span");
      const index = visibleSteps.indexOf(n);
      if (span && index >= 0) span.textContent = String(index + 1);
    });

    if (progressFill) {
      const index = Math.max(visibleSteps.indexOf(currentStep), 0);
      progressFill.style.width = (index / (visibleSteps.length - 1)) * 100 + "%";
    }
    if (nextBtn) nextBtn.disabled = currentStep === STEP_SUMMARY;
    if (prevBtn) prevBtn.disabled = currentStep === firstStep;
  }

  function validateDimensions() {
    const widthInput  = document.getElementById("cushion-width");
    const heightInput = document.getElementById("cushion-height");
    const widthError  = document.getElementById("cushion-width-error");
    const heightError = document.getElementById("cushion-height-error");

    const w    = parseFloat(widthInput.value);
    const h    = parseFloat(heightInput.value);
    const minW = parseFloat(widthInput.dataset.min);
    const maxW = parseFloat(widthInput.dataset.max);
    const minH = parseFloat(heightInput.dataset.min);
    const maxH = parseFloat(heightInput.dataset.max);

    let valid = true;

    if (isNaN(w) || w < minW || w > maxW) {
      widthError.style.display = "block";
      valid = false;
    } else {
      widthError.style.display = "none";
    }

    if (isNaN(h) || h < minH || h > maxH) {
      heightError.style.display = "block";
      valid = false;
    } else {
      heightError.style.display = "none";
    }

    return valid;
  }

  function validateFabricStep() {
    const errorEl = document.getElementById("cushion-step-fabric-error");
    const selected = siblings.some(item => item.id === cushionData.variantId);
    if (!selected) {
      if (errorEl) {
        errorEl.textContent = MSG_NO_FABRIC;
        errorEl.style.display = "block";
      }
      return false;
    }
    if (errorEl) errorEl.style.display = "none";
    return true;
  }

  function hasUnavailableColor() {
    return selectedBaseSoldOut || (hasAccentPicker() && selectedAccentSoldOut);
  }

  function validateColorStep() {
    const errorEl = document.getElementById("cushion-step1-error");
    if (!selectedBaseColor) {
      if (errorEl) {
        errorEl.textContent = MSG_NO_BASE_COLOR;
        errorEl.style.display = "block";
      }
      return false;
    }
    if (selectedBaseSoldOut) {
      if (errorEl) {
        errorEl.textContent = MSG_SOLD_OUT_BLOCKED;
        errorEl.style.display = "block";
      }
      return false;
    }
    if (hasAccentPicker() && !selectedAccentColor) {
      if (errorEl) {
        errorEl.textContent = MSG_NO_ACCENT_COLOR;
        errorEl.style.display = "block";
      }
      return false;
    }
    if (hasAccentPicker() && selectedAccentSoldOut) {
      if (errorEl) {
        errorEl.textContent = MSG_SOLD_OUT_BLOCKED;
        errorEl.style.display = "block";
      }
      return false;
    }
    if (errorEl) errorEl.style.display = "none";
    return true;
  }

  function validateMeasureStep() {
    const errorEl = document.getElementById("cushion-step2-error");
    const w = document.getElementById("cushion-width")?.value.trim();
    const h = document.getElementById("cushion-height")?.value.trim();
    if (w === "" || h === "") {
      if (errorEl) errorEl.style.display = "block";
      return false;
    }
    if (errorEl) errorEl.style.display = "none";
    return validateDimensions();
  }

  function validateStep(step) {
    if (step === STEP_FABRIC) return validateFabricStep();
    if (step === STEP_COLOR) return validateColorStep();
    if (step === STEP_MEASURE) return validateMeasureStep();
    return true;
  }

  function isStepFilled(step) {
    if (step === STEP_FABRIC) {
      return !hasFabricStep || siblings.some(item => item.id === cushionData.variantId);
    }
    if (step === STEP_COLOR) {
      if (!selectedBaseColor || selectedBaseSoldOut) return false;
      if (hasAccentPicker() && (!selectedAccentColor || selectedAccentSoldOut)) return false;
      return true;
    }
    if (step === STEP_MEASURE) {
      const widthInput  = document.getElementById("cushion-width");
      const heightInput = document.getElementById("cushion-height");
      if (!widthInput || !heightInput) return false;
      const w    = parseFloat(widthInput.value);
      const h    = parseFloat(heightInput.value);
      const minW = parseFloat(widthInput.dataset.min);
      const maxW = parseFloat(widthInput.dataset.max);
      const minH = parseFloat(heightInput.dataset.min);
      const maxH = parseFloat(heightInput.dataset.max);
      return !isNaN(w) && !isNaN(h) && w >= minW && w <= maxW && h >= minH && h <= maxH;
    }
    if (step === STEP_SUMMARY) return isStepFilled(STEP_MEASURE);
    return false;
  }

  function isStepClickable(step) {
    const visibleSteps = getVisibleSteps();
    if (!visibleSteps.includes(step) || step === currentStep) return false;
    const targetIndex = visibleSteps.indexOf(step);
    for (let i = 0; i <= targetIndex; i++) {
      if (!isStepFilled(visibleSteps[i])) return false;
    }
    return true;
  }

  function goToStep(targetStep, options = {}) {
    const requireFilled = options.requireFilled !== false;
    const visibleSteps = getVisibleSteps();
    if (!visibleSteps.includes(targetStep) || targetStep === currentStep) return;
    if (requireFilled && !isStepClickable(targetStep)) return;

    if (targetStep > currentStep) {
      const currentIndex = visibleSteps.indexOf(currentStep);
      const targetIndex = visibleSteps.indexOf(targetStep);
      for (let i = currentIndex; i < targetIndex; i++) {
        if (!validateStep(visibleSteps[i])) {
          currentStep = visibleSteps[i];
          updateUI();
          return;
        }
      }
    }

    currentStep = targetStep;
    updateSummary();
    updateUI();
  }

  function handleProgressActivate(e) {
    const target = e.target.closest("[data-step]");
    if (!target) return;
    if (!target.closest(".progress-bar, .step-titles")) return;
    const step = parseInt(target.dataset.step, 10);
    if (isNaN(step) || !isStepClickable(step)) return;
    goToStep(step);
  }

  function handleProgressKeydown(e) {
    if (e.key !== "Enter" && e.key !== " ") return;
    const target = e.target.closest("[data-step]");
    if (!target) return;
    if (!target.closest(".progress-bar, .step-titles")) return;
    e.preventDefault();
    const step = parseInt(target.dataset.step, 10);
    if (isNaN(step) || !isStepClickable(step)) return;
    goToStep(step);
  }

  nextBtn?.addEventListener("click", () => {
    const visibleSteps = getVisibleSteps();
    const index = visibleSteps.indexOf(currentStep);
    if (index >= 0 && index < visibleSteps.length - 1) {
      goToStep(visibleSteps[index + 1], { requireFilled: false });
    }
  });

  prevBtn?.addEventListener("click", () => {
    const visibleSteps = getVisibleSteps();
    const index = visibleSteps.indexOf(currentStep);
    if (index > 0) goToStep(visibleSteps[index - 1]);
  });

  const progressRoot = document.querySelector(".cushion-configurator-sec .progress-container");
  progressRoot?.addEventListener("click", handleProgressActivate);
  progressRoot?.addEventListener("keydown", handleProgressKeydown);

  // ─── Stoff-Schritt ─────────────────────────────────────────────────────────

  function applyFabric(variant) {
    if (!variant) return;

    cushionData.variantId     = variant.id;
    cushionData.variantTitle  = variant.title;
    cushionData.fabricTitle   = variant.option2 || null;
    cushionData.fabricFormula = variant.fabricFormula || "";
    cushionData.image         = variant.image || cushionData.image;
    cushionData.baseColors    = Array.isArray(variant.baseColors) ? variant.baseColors : null;
    cushionData.accentColors  = Array.isArray(variant.accentColors) ? variant.accentColors : null;
    cushionData.cushionColors = (variant.colors && variant.colors.length)
      ? variant.colors
      : (cushionData.cushionColors || []);
    persistCushionData();

    applyProductImage();
    refreshColorPickers();

    lastUnitPrice = null;
    document.querySelectorAll(".subtotal-price, .total-price").forEach(el => {
      el.textContent = "—";
    });
    updateSummary();
    if (getDimWidth() !== null && getDimHeight() !== null) {
      triggerPricePreview();
    }
  }

  function updateFabricSelectionUI(variantId) {
    document.querySelectorAll("#cushion-fabric-picker .cushion-conf__fabric").forEach(btn => {
      const selected = parseInt(btn.dataset.variantId, 10) === variantId;
      btn.classList.toggle("is-selected", selected);
      btn.setAttribute("aria-pressed", selected ? "true" : "false");
      btn.setAttribute("aria-checked", selected ? "true" : "false");
    });
  }

  function handleFabricSelect(variant) {
    if (variant.id !== cushionData.variantId) {
      applyFabric(variant);
    }
    updateFabricSelectionUI(variant.id);
  }

  function renderFabricCards() {
    const container = document.getElementById("cushion-fabric-picker");
    if (!container || !hasFabricStep) return;
    container.innerHTML = "";

    siblings.forEach(variant => {
      const label = variant.option2 || variant.title;
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "cushion-conf__fabric";
      btn.dataset.variantId = String(variant.id);
      btn.setAttribute("role", "radio");
      btn.setAttribute("aria-label", label);
      const isSelected = variant.id === cushionData.variantId;
      btn.setAttribute("aria-pressed", isSelected ? "true" : "false");
      btn.setAttribute("aria-checked", isSelected ? "true" : "false");
      if (isSelected) btn.classList.add("is-selected");

      if (variant.image) {
        const img = document.createElement("img");
        img.src = variant.image;
        img.alt = label;
        img.width = 120;
        img.height = 80;
        btn.appendChild(img);
      }

      const span = document.createElement("span");
      span.className = "cushion-conf__fabric-label";
      span.textContent = label;
      btn.appendChild(span);

      btn.addEventListener("click", () => handleFabricSelect(variant));
      container.appendChild(btn);
    });

    container.addEventListener("keydown", e => {
      if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
      const buttons = [...container.querySelectorAll(".cushion-conf__fabric")];
      const index = buttons.indexOf(document.activeElement);
      if (index < 0) return;
      e.preventDefault();
      const next = e.key === "ArrowRight"
        ? (index + 1) % buttons.length
        : (index - 1 + buttons.length) % buttons.length;
      buttons[next].focus();
      buttons[next].click();
    });
  }

  // ─── Farb-Swatches rendern ─────────────────────────────────────────────────

  function renderSwatches(containerId, colors) {
    const container = document.getElementById(containerId);
    if (!container) return;
    container.innerHTML = "";

    (colors || []).forEach((color, index) => {
      const btn = document.createElement("button");
      btn.type      = "button";
      btn.className = "cushion-conf__swatch";
      btn.dataset.colorName = color.name;
      btn.dataset.colorHex = color.hex || "";
      btn.dataset.swatchUrl = color.swatchUrl || "";
      btn.dataset.previewUrl = color.previewUrl || color.swatchUrl || "";
      btn.dataset.soldOut = color.soldOut ? "true" : "false";
      btn.style.backgroundColor = color.hex;
      if (color.soldOut) {
        btn.classList.add("is-sold-out");
        btn.title = formatColorProperty(color.name, true);
        btn.setAttribute("aria-label", formatColorProperty(color.name, true));
      } else {
        btn.title = color.name;
        btn.setAttribute("aria-label", color.name);
      }

      if (color.swatchUrl) {
        const img = document.createElement("img");
        img.src    = color.swatchUrl;
        img.alt    = color.name;
        img.width  = 60;
        img.height = 60;
        if (index >= 6) img.loading = "lazy";
        btn.appendChild(img);
      }

      container.appendChild(btn);
    });
  }

  const warmedPreviewUrls = new Set();

  function prefetchPreview(url) {
    if (!url || warmedPreviewUrls.has(url)) return;
    warmedPreviewUrls.add(url);
    const img = new Image();
    img.decoding = "async";
    img.src = url;
  }

  function updateColorPreview(previewId, btn) {
    const preview = document.getElementById(previewId);
    if (!preview) return;
    const col = preview.closest(".cushion-conf__preview-col");
    if (!btn) {
      if (col) col.hidden = true;
      preview.style.backgroundColor = "";
      preview.replaceChildren();
      return;
    }
    if (col) col.hidden = false;
    preview.style.backgroundColor = btn.dataset.colorHex || "";
    const previewUrl = btn.dataset.previewUrl || btn.dataset.swatchUrl || "";
    const swatchUrl = btn.dataset.swatchUrl || "";
    const currentImg = preview.querySelector("img");
    if (currentImg && currentImg.dataset.previewUrl === previewUrl) return;

    preview.replaceChildren();
    if (!previewUrl) return;

    const img = document.createElement("img");
    img.alt = btn.dataset.colorName || "";
    img.decoding = "async";
    img.fetchPriority = "high";
    img.dataset.previewUrl = previewUrl;

    if (swatchUrl && swatchUrl !== previewUrl) {
      img.src = swatchUrl;
      const hiRes = new Image();
      hiRes.onload = () => {
        if (img.dataset.previewUrl === previewUrl) img.src = previewUrl;
      };
      hiRes.src = previewUrl;
      warmedPreviewUrls.add(previewUrl);
    } else {
      img.src = previewUrl;
      warmedPreviewUrls.add(previewUrl);
    }

    preview.appendChild(img);
  }

  function applySwatchSelection(picker, btn, labelId, previewId, handleSelect) {
    if (!picker || !btn) return;
    picker.querySelectorAll(".cushion-conf__swatch").forEach(item => item.classList.remove("is-selected"));
    btn.classList.add("is-selected");
    handleSelect(btn.dataset.colorName, btn.dataset.soldOut === "true");
    renderColorName(document.getElementById(labelId), btn.dataset.colorName || "", btn.dataset.soldOut === "true");
    updateColorPreview(previewId, btn);
  }

  function preselectFirstSwatch(pickerId, labelId, previewId, handleSelect) {
    const picker = document.getElementById(pickerId);
    const first = picker?.querySelector(".cushion-conf__swatch:not(.is-sold-out)")
      || picker?.querySelector(".cushion-conf__swatch");
    if (!first) {
      handleSelect(null, false);
      const label = document.getElementById(labelId);
      if (label) label.replaceChildren();
      updateColorPreview(previewId, null);
      return;
    }
    applySwatchSelection(picker, first, labelId, previewId, handleSelect);
  }

  function refreshColorPickers() {
    const firstBase = getBaseColors().find(color => !color.soldOut);
    if (firstBase) prefetchPreview(firstBase.previewUrl || firstBase.swatchUrl);
    if (hasAccentPicker()) {
      const firstAccent = getAccentColors().find(color => !color.soldOut);
      if (firstAccent) prefetchPreview(firstAccent.previewUrl || firstAccent.swatchUrl);
    }

    renderSwatches("base-color-picker", getBaseColors());
    renderSwatches("accent-color-picker", getAccentColors());
    updateAccentVisibility();
    preselectFirstSwatch("base-color-picker", "base-color-label", "base-color-preview", (v, soldOut) => {
      selectedBaseColor = v;
      selectedBaseSoldOut = Boolean(soldOut);
    });
    if (hasAccentPicker()) {
      preselectFirstSwatch("accent-color-picker", "accent-color-label", "accent-color-preview", (v, soldOut) => {
        selectedAccentColor = v;
        selectedAccentSoldOut = Boolean(soldOut);
      });
    } else {
      selectedAccentColor = null;
      selectedAccentSoldOut = false;
      const accentLabel = document.getElementById("accent-color-label");
      if (accentLabel) accentLabel.textContent = "";
      updateColorPreview("accent-color-preview", null);
    }
    updateSummary();
  }

  function bindSwatchPicker(pickerId, labelId, previewId, handleSelect) {
    const picker = document.getElementById(pickerId);
    if (!picker || picker.dataset.bound === "true") return;
    picker.dataset.bound = "true";
    picker.addEventListener("click", e => {
      const btn = e.target.closest(".cushion-conf__swatch");
      if (!btn || !picker.contains(btn)) return;
      applySwatchSelection(picker, btn, labelId, previewId, handleSelect);
      updateSummary();
      validateColorStep();
    });
    picker.addEventListener("pointerenter", e => {
      const btn = e.target.closest(".cushion-conf__swatch");
      if (!btn || !picker.contains(btn)) return;
      prefetchPreview(btn.dataset.previewUrl || btn.dataset.swatchUrl);
    }, true);
  }

  renderFabricCards();
  bindSwatchPicker("base-color-picker", "base-color-label", "base-color-preview", (v, soldOut) => {
    selectedBaseColor = v;
    selectedBaseSoldOut = Boolean(soldOut);
  });
  bindSwatchPicker("accent-color-picker", "accent-color-label", "accent-color-preview", (v, soldOut) => {
    selectedAccentColor = v;
    selectedAccentSoldOut = Boolean(soldOut);
  });
  refreshColorPickers();

  // ─── Live-Preis-Preview (debounced, 400ms) ─────────────────────────────────

  let previewTimeout;

  function triggerPricePreview() {
    clearTimeout(previewTimeout);
    previewTimeout = setTimeout(fetchPreview, 400);
  }

  function fetchPreview() {
    const widthCm  = getDimWidth();
    const heightCm = getDimHeight();
    if (widthCm === null || heightCm === null) return;

    fetch(`${WORKER_URL}/preview`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        variantId:  cushionData.variantId,
        widthCm,
        heightCm,
        tape:       "",
        headerType: "ribbon",
      }),
      signal: AbortSignal.timeout(5000),
    })
    .then(r => r.json())
    .then(({ price }) => {
      lastUnitPrice = parseFloat(price);
      updateTotals();
    })
    .catch(() => {});
  }

  document.getElementById("cushion-width")?.addEventListener("input", () => {
    validateDimensions();
    updateSummary();
    triggerPricePreview();
  });
  document.getElementById("cushion-height")?.addEventListener("input", () => {
    validateDimensions();
    updateSummary();
    triggerPricePreview();
  });
  document.getElementById("cushion-quantity")?.addEventListener("input", updateTotals);

  // ─── Add to Cart ───────────────────────────────────────────────────────────

  document.getElementById("cushion-atc")?.addEventListener("click", handleCushionATC);

  function handleCushionATC() {
    const widthCm  = getDimWidth();
    const heightCm = getDimHeight();
    const quantity = getQuantity();

    if (widthCm === null || heightCm === null) {
      alert("Bitte Breite und Maß angeben.");
      return;
    }
    if (!selectedBaseColor) {
      alert(MSG_NO_BASE_COLOR);
      return;
    }
    if (hasAccentPicker() && !selectedAccentColor) {
      alert(MSG_NO_ACCENT_COLOR);
      return;
    }
    if (hasUnavailableColor()) {
      alert(MSG_SOLD_OUT_BLOCKED);
      return;
    }

    fetch(`${WORKER_URL}/calculate`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        variantId:    cushionData.variantId,
        widthCm,
        heightCm,
        tape:         "",
        headerType:   "ribbon",
        base_color:   selectedBaseColor,
        accent_color: selectedAccentColor || undefined,
      }),
      signal: AbortSignal.timeout(12000),
    })
    .then(r => {
      if (!r.ok) throw new Error(`Worker error: ${r.status}`);
      return r.json();
    })
    .then(({ variantId: configVariantId }) => {
      const properties = {
        "Typ":            cushionData.typeTitle || cushionData.variantTitle || "",
        "Grundfarbe":     formatColorProperty(selectedBaseColor, selectedBaseSoldOut),
        [cfg.labelWidth]: `${widthCm} cm`,
        [cfg.labelHeight]: `${heightCm} cm`,
      };
      if (cushionData.fabricTitle) properties["Stoff"] = cushionData.fabricTitle;
      if (selectedAccentColor) properties["Akzentfarbe"] = formatColorProperty(selectedAccentColor, selectedAccentSoldOut);
      Object.keys(properties).forEach(k => { if (!properties[k]) delete properties[k]; });

      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: parseInt(configVariantId), quantity, properties }),
        signal: AbortSignal.timeout(8000),
      });
    })
    .then(r => r.json())
    .then(() => updateCartDrawer(true))
    .catch(err => {
      console.error("Cushion ATC error:", err);
      alert("Fehler beim Hinzufügen zum Warenkorb. Bitte erneut versuchen.");
    });
  }

  // ─── Cart Drawer ───────────────────────────────────────────────────────────

  function updateCartDrawer(openMiniCart) {
    fetch("/cart.js")
      .then(r => r.json())
      .then(cart => {
        const counter = document.querySelector(".header__cart-count");
        if (counter) counter.textContent = cart.item_count ?? 0;
        const cartUrl = window.themeVariables?.routes?.cartUrl ?? "/cart";
        return fetch(`${cartUrl}?section_id=mini-cart`);
      })
      .then(r => r.text())
      .then(html => {
        const drawer = document.querySelector("cart-drawer");
        if (drawer) {
          drawer.innerHTML = new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector("cart-drawer")?.innerHTML ?? "";
        }
        if (openMiniCart) {
          const mini = document.getElementById("mini-cart");
          if (mini) {
            mini.setAttribute("open", "true");
            document.body.classList.add("overflow-hidden");
          }
        }
      })
      .catch(err => console.error("Cart drawer error:", err));
  }

  // ─── Init ──────────────────────────────────────────────────────────────────

  updateUI();
  updateSummary();
});
